import { isRouteErrorResponse, useLocation, useRouteError } from "react-router-dom";
import { AppErrorFallback, type AppErrorContext } from "@/components/AppErrorFallback";

function resolveContext(pathname: string): AppErrorContext {
  return pathname.startsWith("/app") ? "app" : "public";
}

export function RouteErrorScreen() {
  const error = useRouteError();
  const { pathname } = useLocation();
  const context = resolveContext(pathname);

  let titleKey: string | undefined;
  let bodyKey: string | undefined;

  if (isRouteErrorResponse(error) && error.status === 404) {
    titleKey = "marketing.notFound.heading";
    bodyKey = "marketing.notFound.lead";
  }

  return (
    <AppErrorFallback
      variant="fullPage"
      context={context}
      titleKey={titleKey}
      bodyKey={bodyKey}
      error={error}
    />
  );
}
